import React from 'react';
import { Box, Typography, Container } from '@mui/material';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'rgba(20, 20, 20, 0.95)',
        borderTop: '1px solid rgba(244, 147, 48, 0.3)',
        mt: 'auto',
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          align="center"
          sx={{
            color: '#bbb',
            fontSize: '0.875rem',
            lineHeight: 1.5,
          }}
        >
          Disclaimer: This website does not own any of the character images, manga artwork, or related media displayed. 
          All images are the property of their respective creators, publishers, and copyright holders. 
          This site is for entertainment purposes only and is not affiliated with any manga publishers or creators.
        </Typography>
      </Container>
    </Box>
  );
}